import { motion } from "framer-motion";
import { GALLERY } from "../data/menu";

export default function Gallery() {
  return (
    <div data-testid="gallery-page" className="pt-32 pb-24">
      <header className="max-w-7xl mx-auto px-6 md:px-10 mb-20">
        <p className="text-[10px] uppercase tracking-[0.3em] text-ember mb-6">From the fire</p>
        <h1 className="font-serif text-6xl md:text-8xl leading-[0.9] tracking-tighter text-charred">
          A <span className="italic text-ember">slow scroll</span><br />through the heat.
        </h1>
      </header>

      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-12 auto-rows-[180px] md:auto-rows-[220px] gap-3 md:gap-4">
          {GALLERY.map((g, i) => {
            const span =
              g.span === "lg"
                ? "col-span-12 md:col-span-7 row-span-2"
                : g.span === "md"
                ? "col-span-7 md:col-span-5 row-span-2"
                : "col-span-5 md:col-span-3 row-span-1";
            return (
              <motion.figure
                key={i}
                initial={{ opacity: 0, scale: 0.98 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, margin: "-40px" }}
                transition={{ duration: 0.6, delay: i * 0.04 }}
                className={`${span} overflow-hidden bg-charred/5 group`}
                data-testid={`gallery-tile-${i}`}
              >
                <img
                  src={g.url}
                  alt={g.alt}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  style={{
                    objectPosition: g.crop === "top" ? "center 22%" : "center center",
                    filter: "saturate(1.06) contrast(1.04)",
                  }}
                  loading="lazy"
                />
              </motion.figure>
            );
          })}
        </div>
      </div>
    </div>
  );
}
